// extracted by mini-css-extract-plugin
export var modal = "solutionModal-module--modal--2U2IX";
export var inner = "solutionModal-module--inner--1m7K4";
export var modalContent = "solutionModal-module--modalContent--1neTE";
export var video = "solutionModal-module--video--2lxC9";
export var modalClose = "solutionModal-module--modalClose--92M3h";
export var active = "solutionModal-module--active--23_35";
export var modalInnerPop = "solutionModal-module--modalInnerPop--Vg4B4";
export var close = "solutionModal-module--close--5ERdh";